<div class="pwa-prompt-container">
    <!-- Close Button -->
    <button mat-icon-button class="ss-dialog-close-btn" (click)="close()">
        <mat-icon>close</mat-icon>
    </button>

    <!-- Header with Icon -->
    <div class="pwa-header">
        <div class="app-icon-wrapper">
            <mat-icon class="app-icon">install_mobile</mat-icon>
        </div>
        <div class="pwa-title">
            <h3>{{'general.pwaInstall3' | transloco}}</h3>
            <p class="pwa-subtitle hide-lt-md">{{'general.pwaInstall2' | transloco}}</p>
        </div>
    </div>

    <!-- Action Buttons -->
    <div class="pwa-actions">
        <button mat-raised-button color="warn" class="install-button" (click)="installPwa()">
            <mat-icon>download</mat-icon>
            <span class="hide-lt-md">{{'ai.install' | transloco}}</span>
            <span class="hide-gt-sm">{{'ai.install' | transloco}}</span>
        </button>
    </div>

    <!-- Don't Show Again Checkbox -->
    <div class="pwa-footer">
        <mat-checkbox [(ngModel)]="isChecked" (change)="onChecked($event.checked)">
            {{'general.dontShow' | transloco}}
        </mat-checkbox>
    </div>
</div>
